import { Rutas } from '@/constants/rutas';

export const NavigationPredictingManagerItems = [
    {
        title: 'Crear alineaciones probables',
        shortTitle: 'Jugar',
        path: Rutas.PREDICTING_MANAGER,
    },
    {
        title: 'Reglas',
        shortTitle: 'Reglas',
        path: Rutas.PREDICTING_MANAGER_RULES,
    },
    {
        title: 'Ranking',
        shortTitle: 'Ranking',
        path: Rutas.PREDICTING_MANAGER_RANKING,
    },
];
